import React from 'react'
import { Link,useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { 
	CRow,CCol,
	CImage,
	CSpinner,CBadge,
	CTooltip,
	CDropdown, CDropdownToggle, CDropdownMenu, CDropdownHeader, CDropdownItem, CDropdownDivider
} from '@coreui/react'
import CIcon from '@coreui/icons-react';
import PropTypes from "prop-types";
import {
	MyDialogview,
} from '../components/index'
import { UFunc } from '../helpers/functions'

const pjson 			= require('../../package.json')
const MyKalendercheck 	= (props) => {
	const {
		height,isShowlink,isShowbadge,isLoadperdate,
		setSessionaktif,showToast,setLoading,prosesExpired,
		...rest
	} = props

	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();

	const uHeighticon			= parseInt(height)||32;
	const uISLoadperdate		= isLoadperdate || false;
	const uISShowlink			= isShowlink || false;
	const uISShowbadge			= isShowbadge || false;

	const uTokenObj				= JSON.parse(localStorage.getItem("token")||"{}");
	const uDatacabangArr		= JSON.parse(localStorage.getItem("cabanglist")||"[]")
	const uDataloadstr			= useSelector(state => state.kalender_load);
	const uDataloadObj			= uDataloadstr && JSON.parse(uDataloadstr || "{}");
	
	const uCabangIDuser			= parseInt(uTokenObj.user_cabangid)||0;
	const [uKalenderloading,setKalenderloading]	= React.useState(false);
	const [uDatakalenderArr,setDatakalenderArr]	= React.useState([]);
	const [uJmlBadge,setJmlBadge]	= React.useState(0);

	//--DLGVIEW--/
	const [uISDlgviewshow,setDlgviewshow]		= React.useState(false);
	const [uDlgviewdataObj,setDlgviewdataObj]	= React.useState({});
	//--END DLGVIEW--/

	//--DOM--//
	const vElikon 				= document.getElementById("idikondropdown");
    const vClientrect 			= vElikon && (vElikon.getBoundingClientRect());

	//console.log('Current top position:', vClientrect, 'px');

	const uJadwalwidth			= (27/100) * window.innerWidth;
	const vTopikon				= ((vClientrect||{}).top || 200) 
			+ ((vClientrect||{}).height || 35) + 35 + (uISShowlink ? 40 : 0);
	const uMaxkalenderheight	= window.innerHeight > 500 
			? window.innerHeight - vTopikon : "";
	//--END DOM--//

	const hdlKlikKalender = (_DATAEVENT) => {
		if(uISShowlink) return;

		if(!_DATAEVENT) return;

		//console.log("(Agendaklinik - hdlKlikViewdata) _DATAEVENT",_DATAEVENT);
		const vHeadertitle	= (_DATAEVENT?.title_db||_DATAEVENT?.title).length > 30
			? (_DATAEVENT?.title_db||_DATAEVENT?.title).substring(0,30).trim()+"..."
			: (_DATAEVENT?.title_db||_DATAEVENT?.title);

		setDlgviewdataObj({
			dlg_header: vHeadertitle,
			title: _DATAEVENT?.title_db,
			tabelid: parseInt(_DATAEVENT?.id) || 0,
			id_cabang: parseInt(_DATAEVENT?.id_cabang) || uCabangIDuser, 
			id_dokter: parseInt(_DATAEVENT?.id_dokter)||0,
			caption_dokter: _DATAEVENT?.caption_dokter,
			id_pasien: parseInt(_DATAEVENT?.id_pasien) || 0,
			tgl_awal: UFunc.DbDate(UFunc.toDatetime(_DATAEVENT?.tgl_start)),
			jam_awal: UFunc.JamMenit(UFunc.toDatetime(_DATAEVENT?.tgl_start)),
			tgl_akhir: UFunc.DbDate(UFunc.toDatetime(_DATAEVENT?.tgl_end)),
			jam_akhir: UFunc.JamMenit(UFunc.toDatetime(_DATAEVENT?.tgl_end)),
			status_allday:_DATAEVENT?.allDay ? "YA" : "TIDAK",
			status_agenda: _DATAEVENT?.status_agenda,
			color: _DATAEVENT?.color,
			deskripsi: _DATAEVENT?.desc,
			tgl_input: _DATAEVENT?.tgl_input,
			userinput: _DATAEVENT?.userinput,
		});
		setDlgviewshow(true);
	}

	const contentDlgview = () => {
		if(!uISDlgviewshow) return (<></>)//>

		const vCabangidvalue= uDlgviewdataObj.id_cabang;
		const vCabangidx	= UFunc.getObjectIndeks(uDatacabangArr,vCabangidvalue);

		const vTglnowDT 	= UFunc.toDate();
		const vTglakhirDT 	= UFunc.toDate(uDlgviewdataObj.tgl_akhir);

		return(
		<>
		<div className="d-none">{JSON.stringify(uDlgviewdataObj)}</div>

		<CRow className="my-3 mx-0">
			<CCol xs="1" className="px-1 text-center">
				<CIcon className="classikonbox mx-0" style={{backgroundColor:uDlgviewdataObj.color}} height={28}/>
			</CCol>
			<CCol className="text-start fw-bolder">
				{uDlgviewdataObj.title || "title"}
			</CCol>
		</CRow>

		{(parseInt(uDlgviewdataObj.id_dokter)||0) > 0 && (
		<CRow className="my-2 mx-0">
			<CCol xs="1" className="px-1 text-center">
				<CIcon icon="cilContact" className="border rounded p-1 bg-info text-white" height={28}/>
			</CCol>
			<CCol className="text-start fw-bolder">
				{uDlgviewdataObj.caption_dokter || "caption_dokter"}
			</CCol>
		</CRow>
		)}

		<CRow className="my-2 mb-0 mx-0">
			<CCol xs="1" className="px-1 text-center">
				<CIcon icon="cilClock" className="border rounded p-1 bg-info text-white" height={28}/>
			</CCol>
			<CCol className="text-start">
				<b>{UFunc.HariAngka(uDlgviewdataObj.tgl_awal)}</b>
				
				{uDlgviewdataObj.status_allday!=="YA" && (
				<>
					<span className="ms-1"/>
					<b>{uDlgviewdataObj.jam_awal}</b>
				</>
				)}

				{(uDlgviewdataObj.status_allday!=="YA"
					|| uDlgviewdataObj.tgl_awal !== uDlgviewdataObj.tgl_akhir
				) && (
				<span className="mx-1">-</span>
				)}
				
				{uDlgviewdataObj.tgl_awal !== uDlgviewdataObj.tgl_akhir && (
					<>
					<b>{UFunc.HariAngka(uDlgviewdataObj.tgl_akhir)}</b>
					</>
				)}

				{uDlgviewdataObj.status_allday!=="YA" && (
				<>
					<span className="ms-1"/>
					<b>{uDlgviewdataObj.jam_akhir}</b>
				</>
				)}
			</CCol>
		</CRow>

		<CRow className="my-0 mb-2 mx-0">
			<CCol xs="1" className="px-2">&nbsp;</CCol>
			<CCol className="text-start classfontsmaller">
			{uDlgviewdataObj.status_allday==="YA" ? (
				<CIcon icon="cilCheckCircle" className="me-1 text-info align-middle" height={20}/>
			) : (
				<CIcon icon="cilXCircle" className="me-1 text-danger align-middle" height={20}/>
			)}
			<small>All Day (Seharian)</small>
			</CCol>
		</CRow>

		<CRow className="my-2 mx-0">
			<CCol xs="1" className="px-1 text-center">
				<CIcon icon="cilStorage" className="border rounded p-1 bg-info text-white" height={28}/>
			</CCol>
			<CCol className="text-start">
				{uDlgviewdataObj.status_agenda!=="CLOSED" ? "REMINDER \/ RESERVASI" : "LIBUR \/ CUTI"}
			</CCol>
		</CRow>

		{(uDlgviewdataObj.deskripsi||"").trim() !== "" && (
		<CRow className="my-2 mx-0">
			<CCol xs="1" className="px-1 text-center">
				<CIcon icon="cilNotes" className="border rounded p-1 bg-info text-white" height={28}/>
			</CCol>
			<CCol className="text-start fst-italic">
				{UFunc.nl2br(uDlgviewdataObj.deskripsi||"-")}
			</CCol>
		</CRow>
		)}

		<CRow className="mt-2 mx-0">
			<CCol xs="1" className="px-1 text-center">
				<CIcon icon="cilUser" className="border rounded p-1 bg-info text-white" height={28}/>
			</CCol>
			<CCol className="text-start text-danger classfontsmaller">
				<>[
				{UFunc.WaktuAngka(uDlgviewdataObj.tgl_input)}
				<span className="mx-1">&middot;</span>
				{uDlgviewdataObj.userinput || "Undf"}
				]</>
			</CCol>
		</CRow>

		</>
		)//>
	}
	
	const apiLoaddata = () => {
		setKalenderloading(true);
		setDatakalenderArr([]);
		setJmlBadge(0);

		/*//--TEST_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
		},2000); return;
		//--END TEST_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_cabangid : uCabangIDuser,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_agendaklinik/ld_dashboard";
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		})
		.then((response)=> { if (response.status === 200) {setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setKalenderloading(false);
			if(output_string.tampil) {
				const vTmpArr	= JSON.parse(output_string.datakalender||"[]");
				setDatakalenderArr(vTmpArr);

				if(uISShowbadge)
					setJmlBadge(parseInt(output_string.jml_kalender)||0);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(MyKalendercheck - apiLoaddata) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired(); return;
			}
		})
		.catch((error) =>{
			setKalenderloading(false);
			console.log("(MyKalendercheck - apiLoaddata) catch-error: "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiLoadtanggal = () => {
		setKalenderloading(true);
		setDatakalenderArr([]);

		/*//--TEST_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
		},2000); return;
		//--END TEST_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_cabangid : (uDataloadObj||{}).id_cabang || uCabangIDuser,
			send_tglload : (uDataloadObj||{}).tgl_load || UFunc.DbDate(),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_agendaklinik/ld_tanggal";
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		})
		.then((response)=> { if (response.status === 200) {setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setKalenderloading(false);
			if(output_string.tampil) {
				const vTmpArr	= JSON.parse(output_string.datakalender||"[]");
				setDatakalenderArr(vTmpArr);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(MyKalendercheck - apiLoadtanggal) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired(); return;
			}
		})
		.catch((error) =>{
			setKalenderloading(false);
			console.log("(MyKalendercheck - apiLoadtanggal) catch-error: "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}

	React.useEffect(()=>{
		if(uISLoadperdate && !uDataloadObj) apiLoadtanggal();
		else apiLoaddata();

		return () => {
			setDlgviewshow(false);
			setDatakalenderArr([]);
			setJmlBadge(0);
			uDispatch({type: "set", kalender_datastr: undefined});
		}
	},[]);
	React.useEffect(()=>{
		if(!uDataloadObj) return;

		uDispatch({type: "set", kalender_load: undefined});
		apiLoadtanggal();
	},[uDataloadObj]);
	React.useEffect(()=>{
		if(uDatakalenderArr.length <= 0) {
			uDispatch({type: "set", kalender_datastr: undefined});
			return;
		}
		if(!uISLoadperdate) return;

		uDispatch({type: "set", kalender_datastr: JSON.stringify(uDatakalenderArr)});
	},[uDatakalenderArr]);

	//console.log("MyKalendercheck - props => "+JSON.stringify(props))
	if(uKalenderloading) return (
		<CSpinner color="primary" className="me-1" size="sm"/>
	)

	return (
	<>
		{uDatakalenderArr.length <= 0 ? (
		<>
			{uISShowlink ? (
			<Link to="/subantrian/agendaklinik">
			<CImage src={pjson.homepage+"api\/images\/menus_agendaklinik.png"} id="idikondropdown" className="align-middle" height={uHeighticon}/>
			</Link>
			) : (
			<CTooltip className="d-none d-lg-block" content="--Tidak Ada Data Kalender">
			<CImage src={pjson.homepage+"api\/images\/menus_agendaklinik.png"} id="idikondropdown" className="align-middle" height={uHeighticon}/>
			</CTooltip>
			)}
		</>
		) : (
		<CDropdown>
		<CDropdownToggle caret={false} className="p-0" color="transparent">
		<CImage src={pjson.homepage+"api\/images\/menus_agendaklinik.png"} id="idikondropdown" className="align-middle" height={uHeighticon}/>
		{uJmlBadge > 0 && (
			<CBadge className="position-absolute" style={{
				top:-5,left:-5,padding:"3px 7px"
			}} color="danger"><small>{uJmlBadge}</small></CBadge>
		)}
		</CDropdownToggle>

		<CDropdownMenu className="classZ1099">
		<div className="overflow-auto" style={{
			minWidth:320,
			width:uJadwalwidth,
			maxHeight:uMaxkalenderheight,
			zIndex: 1050,
		}}>
		{(uDatakalenderArr.map((vItems,vKeys)=>{
			return (
			<CDropdownItem onClick={()=>hdlKlikKalender(vItems)} 
				className={"d-flex"+(uISShowlink ? "" : " classcursorpointer")} 
				style={{ whiteSpace: "normal" }} 
				key={vKeys}>
				<div>
				<CIcon className="border rounded" style={{backgroundColor:vItems.color}} height={25}/>
				</div>
				
				<div className="d-block ps-2">
				<div className="fw-bolder text-capitalize">
				{(vItems.title||"").length > 30 
					? vItems.title.substring(0,30).trim()+"..."
					: vItems.title}
				</div>

				<div>
				<small className="mx-2 fst-italic">
					<span>{UFunc.HariAngka(vItems.tgl_start)}</span>

					{(vItems.status_allday!=="YA") && (
					<span className="ms-1">{UFunc.JamMenit(vItems.tgl_start)}</span>
					)}

					{(UFunc.DbDate(UFunc.toDatetime(vItems.tgl_end)) !== UFunc.DbDate(UFunc.toDatetime(vItems.tgl_start))
						|| vItems.status_allday!=="YA"
					) && (
					<span className="mx-1">-</span>
					)}

					{UFunc.DbDate(UFunc.toDatetime(vItems.tgl_end)) !== UFunc.DbDate(UFunc.toDatetime(vItems.tgl_start)) && (
					<span className="me-1">{UFunc.HariAngka(vItems.tgl_end)}</span>
					)}
					
					{(vItems.status_allday!=="YA") && (
					<span>{UFunc.JamMenit(vItems.tgl_end)}</span>
					)}
				</small>
				</div>
				</div>
			</CDropdownItem>
			);
		}))}
		</div>

		<CDropdownDivider className={uISShowlink ? "" : "d-none"}/>

		<CDropdownItem onClick={()=>uNavigate("/subantrian/agendaklinik")} 
			className={"text-end classcursorpointer"+(uISShowlink ? "" : " d-none")}>
			<small className="text-info">
			Lihat Detil
			<CIcon icon="cilArrowRight" className="align-middle" height={18}/>
			</small>
		</CDropdownItem>
		</CDropdownMenu>
		</CDropdown>
		)}

		<MyDialogview
			options={{size:null,centered:true}}
			show={uISDlgviewshow} 
			dialogHeader={uDlgviewdataObj.dlg_header}
			toggle={()=>setDlgviewshow(false)}
			renderContent={contentDlgview()}/>
	</>
	)//>
}

export default MyKalendercheck